import React, { useEffect, useState } from 'react';

export default function CountdownTimer() {
    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        const updateTimer = () => {
            const now = new Date();
            let nextExecution = new Date(now);

            // Cron schedule: at minute 0 of hours 0, 6, 12, 18 → 0 */6 * * *
            const currentHour = now.getHours();
            let nextHour = Math.floor(currentHour / 6) * 6 + 6;
            if (nextHour >= 24) {
                nextHour = nextHour % 24;
                nextExecution.setDate(nextExecution.getDate() + 1);
            }
            nextExecution.setHours(nextHour, 0, 0, 0);

            const diff = nextExecution - now;
            const hours = Math.floor(diff / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            const formatted = `${hours.toString().padStart(2, '0')}:${minutes
                .toString()
                .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

            setTimeLeft(formatted);
        };

        updateTimer();
        const timerId = setInterval(updateTimer, 1000);
        return () => clearInterval(timerId);
    }, []);

    return <span>{timeLeft}</span>;
}
